import { observer } from "mobx-react-lite";
import ChangePassword from "../security/ChangePassword";
import BorderWidget from "../widgets/border_widget";
import { Constants } from "../../utils/constants";

function Security({ jobStore, authStore }) {
  jobStore.setNavigation("setting");

  return (
    <BorderWidget
      sx={{
        boxShadow: "0px 1px 3px 0px #0000001a",
        padding: `calc(${Constants.Styles.spacing} * 6)`,
        borderRadius: `calc(${Constants.Styles.radius.base} + 4px)`,
      }}
    >
      <ChangePassword authStore={authStore} />
    </BorderWidget>
  );
}

export default observer(Security);
